<template>
  <div>
    <b-row v-if="dataLoading">
      <b-col

        cols="12"
        md="12"
      >
        <pre-loading />
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col
        v-if="!itemData.id"
        cols="12"
        md="12"
      >
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <b-alert
              show
              variant="warning"
            >
              <div class="text-center alert-body">
                <feather-icon icon="InfoIcon" />
                Teklif Dokümanı Yüklenmemiş.
              </div>
            </b-alert>
          </b-col>
          <b-col
            v-if="offerData.id_purchase_offer_status !== '7' && !offerData.id_confirmed_user"
            cols="12"
            md="12"
          >
            <b-row>
              <b-col
                cols="12"
                md="12"
              >
                <b-form-group label="Doküman Başlığı">
                  <b-form-input
                    v-model="itemData.title"
                    placeholder="Giriniz"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <b-form-group label="Doküman Dosyası">
                  <b-form-file
                    id="file-upload"
                    v-model="itemData.filename"
                    placeholder="Bir dosya seçin.."
                    drop-placeholder="Dosyayı buraya bırakın.."
                    browse-text="Dosya Seçin"
                    :disabled="uploading"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <b-button
                  block
                  variant="primary"
                  :disabled="uploading"
                  @click="saveDocument"
                >
                  <feather-icon
                    v-if="!uploading"
                    icon="UploadIcon"
                  />
                  <b-spinner
                    v-if="uploading"
                    small
                  />
                  Yükle
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        v-if="itemData.id"
        cols="12"
        md="12"
      >
        <b-row class="d-flex justify-content-center align-items-center">
          <b-col>
            <b-media no-body>
              <b-media-aside
                class="mr-2"
              >
                <b-avatar
                  size="48"
                  variant="light-info"
                >
                  <feather-icon
                    size="24"
                    icon="FileTextIcon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ itemData.title }}
                </h4>
                <b-card-text class="font-small-3 mb-0">
                  Teklif Dokümanı
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
          <b-col md="auto">
            <b-button
              variant="flat-primary"
              :href="itemData.fileUrl"
              target="_blank"
              size="sm"
              class="mr-1"
            >
              <feather-icon icon="EyeIcon" />
              Görüntüle
            </b-button>
            <b-button
              variant="flat-danger"
              size="sm"
              :disabled="offerData.id_confirmed_user !== null || lineData.id_confirmed_user !== null || offerData.id_purchase_offer_status === '7'"
              @click="removeData"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BFormGroup, BFormFile, BButton, BAlert, BRow, BCol, BFormInput, BSpinner, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'PurchaseOfferLinesDocumentForm',
  components: {
    PreLoading,
    BFormGroup,
    BFormFile,
    BButton,
    BAlert,
    BRow,
    BCol,
    BFormInput,
    BSpinner,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
  },
  data() {
    return {
      uploading: false,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['purchaseOfferDocuments/dataItem']
    },
    lineData() {
      return this.$store.getters['purchaseOfferLines/dataItem']
    },
    dataLoading() {
      return this.$store.getters['purchaseOfferDocuments/dataLoading']
    },
    offerData() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
  created() {

  },
  methods: {
    saveDocument() {
      if (this.itemData.title && this.itemData.filename) {
        this.uploading = true
        this.itemData.id_purchase_offer_lines = this.lineData.id
        this.$store.dispatch('purchaseOfferDocuments/saveData', this.itemData)
          .then(res => {
            if (res.status) {
              this.uploading = false
              this.$store.dispatch('purchaseOfferDocuments/getDataItem2', this.lineData.id)
                .then(resp => {
                  if (resp) {
                    this.$store.dispatch('purchaseOffers/getDataItem', { id: this.$route.params.id })
                  }
                })
            } else {
              this.uploading = false
              this.$swal({
                title: 'İşlem Başarısız',
                text: res.message ? res.message : 'Teknik bir hata sebebi ile işlem başarısız.',
                icon: 'error',
                confirmButtonText: this.$store.state.app.removeResultClose,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            }
          })
      } else {
        this.uploading = false
        this.$swal({
          title: 'İşlem Başarısız',
          text: 'Lütfen dosya başlığı ve seçilen dosya alanlarını kontrol ediniz.',
          icon: 'error',
          confirmButtonText: this.$store.state.app.removeResultClose,
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }
    },
    removeData() {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('purchaseOfferDocuments/removeData', this.itemData.id)
            .then(res => {
              if (res.status) {
                this.$store.dispatch('purchaseOfferDocuments/getDataItem2', this.lineData.id)
              }
            })
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
